import React from "react";
import { Navigate } from "react-router-dom";

function StudentProtectedRoute({ children }) {
  const isLoggedIn = localStorage.getItem("studentAuth") === "true";

  if (!isLoggedIn) {
    return <Navigate to="/student/login" replace />;
  }

  return children;
}

export default StudentProtectedRoute;